import React from 'react'
import ClientLibraryHref from './ClientLibraryHref'

class ClientLibraryListView extends React.Component {
  render() {
    const rows = this.props.data.map((job) => {
      let href = ClientLibraryHref({job: job, roleType: this.props.roleType})

      return (
        <a key={job.id} className="list-group-item u-hover--raised" href={href}>
          <div className="d-flex w-100 align-items-center cursor-pointer row">
            <div className="d-flex flex-column offset-1 col-5 col-sm-2 grey-text text-darken-3">
              {job.publish_on}
              <small className="grey-text text-darken-2">{job.type}</small>
            </div>

            <small className="d-flex flex-column grey-text text-darken-2 col u-wrap">
              {job.size}
            </small>

            <small className="d-none d-md-flex flex-column grey-text text-darken-2 col u-wrap">
              {job.territories}
            </small>

            <small className="d-none d-lg-flex flex-column grey-text text-darken-2 col u-wrap">
              {job.publications}
            </small>

            <small className="d-none d-lg-flex flex-column grey-text text-darken-2 col u-wrap text-center" title={job.modified_at}>
              {job.formatted_modified_at}
            </small>

            <div className="d-flex grey-text text-darken-2 flex-column col-1 align-items-center ml-auto">
              <i className="material-icons">keyboard_arrow_right</i>
            </div>
          </div>
        </a>
      )
    },(this))

    return (
      <ul className="list-group list-group-flush mb-6">
        {rows}
      </ul>
    )
  }
}

export default ClientLibraryListView
